import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { EASE } from "@/lib/motion";

function getTarget() {
  const now = new Date();
  let target = new Date(now.getFullYear(), 3, 15, 23, 59, 59);
  if (now > target) target = new Date(now.getFullYear() + 1, 3, 15, 23, 59, 59);
  return target;
}

export default function Countdown() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(t);
  }, []);

  const target = getTarget();
  const diff = Math.max(0, target - now);
  const units = [
    [Math.floor(diff / 86400000), "days"],
    [Math.floor((diff % 86400000) / 3600000), "hours"],
    [Math.floor((diff % 3600000) / 60000), "minutes"],
  ];

  return (
    <motion.div
      data-testid="filing-countdown"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 1.05, ease: EASE }}
      className="glass border border-steel-border p-8 shadow-[0_0_50px_rgba(168,85,247,0.08)]"
    >
      <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-steel-muted">Federal filing deadline</p>
      <p className="mt-2 font-display text-xl font-medium text-steel-text">April 15, {target.getFullYear()}</p>
      <div className="mt-6 grid grid-cols-3 gap-2">
        {units.map(([v, label]) => (
          <div key={label} className="text-center">
            <span
              data-testid={`countdown-${label}`}
              className="neon-text font-mono text-2xl font-medium tabular-nums text-steel-brass sm:text-3xl"
            >
              {String(v).padStart(2, "0")}
            </span>
            <p className="mt-1 font-mono text-[9px] uppercase tracking-[0.2em] text-steel-muted">{label}</p>
          </div>
        ))}
      </div>
      <div className="hairline-glow mt-6 w-full" />
      <p className="mt-4 text-xs leading-relaxed text-steel-muted">
        Earlier is easier — preparation spots fill quickly as the deadline approaches.
      </p>
    </motion.div>
  );
}
